define(
  'modules/utils',
  [
    'modules/preload'
  ],
  function (
    Preload
  ) {
    'use strict';

    var isNonProd = window.nxExperienceSettings.environment !== 'production';
    var isIE = (!!navigator.userAgent.match(/Trident.*rv\:11\./));
    var tabletBreakpoint = 768;
    var desktopBreakpoint = 992;
    var videoLoadedCheckRate = 250;
    var triggeredEvents = [];
    var blobs = {};
    var configData;


    function init (config) {
      configData = config;
    }

    /**
     * Define one or more event listeners.
     * @param  {Array|String}  event(s) for listeners to be set up for
     * @param  {Function}      function to carry out if all requirements are met
     */
    function addListener (eventName, callback) {
      if (!Array.isArray(eventName)) {
        eventName = [eventName];
      }

      for (var index in eventName) {
        window.addEventListener(eventName[index], callback);
      }
    }

    function removeListener (eventName, callback) {
      window.removeEventListener(eventName, callback);
    }

    /**
     * Define one or more event listeners that will only carry out the callback when events meeting all the defined requirements are carried out (via the CustomEvent details property). Callback is executed at the time when the final requirement is fulfilled.
     * @param  {Array|String}  event(s) for listeners to be set up for
     * @param  {Object}        object containing a property for each requirement
     * @param  {Function}      function to carry out if all requirements are met
     */
    function handleListenerWithRequirements (eventName, eventRequirements, callback) {

      // Determine if one or more events listeners needs to be defined, and align the formatting accordingly
      if (!Array.isArray(eventName)) {
        eventName = [eventName];
      }

      // For each event, define the listener
      for (var index in eventName) {

        var handler = function (event) {
          // Only bother if there is the possibility for a requirement present
          if (event.detail) {
            // Get a list of all the requirements
            var requirementKeys = Object.keys(eventRequirements)
            , eventDetailKeys = Object.keys(event.detail)
            , requirementsMet = true;

            // Copy accross only the relevant properties
            for (var edKey in eventDetailKeys) {
              if (eventRequirements.hasOwnProperty(eventDetailKeys[edKey])) {
                eventRequirements[eventDetailKeys[edKey]] = event.detail[eventDetailKeys[edKey]];
              }
            }

            // Loop through the keys and check if they are all true, flag accordingly
            for (var rKey in requirementKeys) {
              if (eventRequirements[requirementKeys[rKey]] == false) {
                requirementsMet = false;
              }
            }

            if (requirementsMet) {
              callback();
            }
          }
        };

        // if the event was triggered before the listener was bound, execute the handler as if the event was received normally
        var triggeredEvent = undefined;
        for (var t = 0; t < triggeredEvents.length; t++) {
          if (triggeredEvents[t].type === eventName[index]) {
            triggeredEvent = triggeredEvents[t];
            break;
          }
        }

        if (triggeredEvent) {
          handler(triggeredEvent);
        } else {
          window.addEventListener(eventName[index], handler);
        }
      }
    }

    function triggerEvent (name, eventDetail) {
      var thisEvent;

      if ( isIE ) {
        // IE11 doesn't support native customEvent....
        thisEvent = document.createEvent('CustomEvent');
        thisEvent.initCustomEvent(name, true, true, eventDetail || {});
      } else {
        thisEvent = new CustomEvent(name, { 'detail': eventDetail || {} });
      }

      triggeredEvents.push(thisEvent);
      window.dispatchEvent(thisEvent);
    }

    function onVideoLoaded (video, callback) {
      if (video.readyState === 4) {
        callback();
      } else {
        setTimeout(function () {
          onVideoLoaded(video, callback);
        }, videoLoadedCheckRate);
      }
    }

    // preload or get cached
    function getBlobs (urls, callback) {
      var result = {};

      if ( !Array.isArray(urls) ) { // ensure array
        urls = [ urls ];
      }

      for (var i = urls.length - 1; i >= 0; i--) { // get any cached & remove them from preload list
        var url = urls[i]
          , cached = blobs[url];

        if ( cached ) {
          result[url] = cached; 
          urls.splice(i, 1);
        }
      }

      if ( !urls.length ) { // nothing new to fetch
        return callback(result);
      }

      var preload = new Preload();

      preload.get(urls, function () { // preload & cache
        for (var i = 0; i < urls.length; i++) {
          var url = urls[i]
            , blob = preload.getItemByURL(url);

          result[url] = blobs[url] = blob;
        }

        return callback(result);
      });
    }

    function getCarViews () {
      return configData.carViews;
    }

    function getSelectedView () {
      return configData.selectedView;
    }

    function setSelectedView (view) {
      if (configData.carViews.hasOwnProperty(view)) {
        configData.selectedView = view;
      }
    }

    function getSubViews () {
      return configData.subViews;
    }

    function getSelectedSubView () {
      return configData.selectedSubView;
    }

    function setSelectedSubView (subView) {
      if (configData.subViews.hasOwnProperty(subView)) {
        configData.selectedSubView = subView;
      }
    }

    function getPageNames () {
      return configData.pageNames;
    }

    function getSelectedPageName () {
      return configData.selectedPageName;
    }

    function setSelectedPageName (pageName) {
      if (configData.pageNames.hasOwnProperty(pageName)) {
        configData.selectedPageName = pageName;
      }
    }

    function getIsMobile () {
      return window.hasOwnProperty('nxExperienceSettings') ? window.nxExperienceSettings.ua.isMobile : (window.navigator.maxTouchPoints > 0 && window.innerWidth < desktopBreakpoint);
    }

    function getIsMobileSize () {
      return window.innerWidth < tabletBreakpoint;
    }

    function getIsTabletSize () {
      return window.innerWidth >= tabletBreakpoint && window.innerWidth < desktopBreakpoint;
    }

    function getIsTouchDevice () {
      return window.navigator.maxTouchPoints > 0;
    }

    function getIsPortrait () {
      return screen.availHeight > screen.availWidth;
    }

    function getIsRTL () {
      var dir = document.querySelector('html').getAttribute('dir');

      return !!dir && dir === 'rtl';
    }

    function getDeviceCategory () {
      return isIE ? 'ie' : (window.innerWidth < 1080) ? 'mobile' : 'desktop';
    }

    function capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function populateTemplateString (template, replacements) {
      var populated = '' + template;

      for (var i = 0; i < replacements.length; i++) {
        populated = populated.replace(new RegExp(replacements[i][0], 'g'), replacements[i][1]);
      }

      return populated;
    }

    function bindOrientationChange (onOrientationChange) {
      // screen.orientation is experimental and unsupported in some browers (eg. iOS Safari), orientationchange is deprecated but still required for these browsers. More details:
      // https://developer.mozilla.org/en-US/docs/Web/API/Screen/orientation
      // https://developer.mozilla.org/en-US/docs/Web/API/Window/orientationchange_event
      if (screen.orientation) {
        screen.orientation.addEventListener('change', function (e) {
          onOrientationChange(e, true);
        });

        return;
      }

      window.addEventListener('orientationchange', function (e) {
        onOrientationChange(e, false);
      });
    }


    return {
      init: init,
      isNonProd: isNonProd,
      isIE: isIE,
      getIsMobile: getIsMobile,
      getIsMobileSize: getIsMobileSize,
      getIsTabletSize: getIsTabletSize,
      getIsTouchDevice: getIsTouchDevice,
      getIsPortrait: getIsPortrait,
      getIsRTL: getIsRTL,
      addListener: addListener,
      removeListener: removeListener,
      handleListenerWithRequirements: handleListenerWithRequirements,
      triggerEvent: triggerEvent,
      onVideoLoaded: onVideoLoaded,
      getBlobs: getBlobs,
      getCarViews: getCarViews,
      getSelectedView: getSelectedView,
      setSelectedView: setSelectedView,
      getSubViews: getSubViews,
      getSelectedSubView: getSelectedSubView,
      setSelectedSubView: setSelectedSubView,
      getPageNames: getPageNames,
      getSelectedPageName: getSelectedPageName,
      setSelectedPageName: setSelectedPageName,
      getDeviceCategory: getDeviceCategory,
      capitalizeFirstLetter: capitalizeFirstLetter,
      populateTemplateString: populateTemplateString,
      bindOrientationChange: bindOrientationChange
    }
});

